import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { IStrapiDocument, PrivacyPolicy } from 'src/app/interfaces/strapi';

import environment from 'src/environments/environment';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf, NgFor } from '@angular/common';
import { BannerComponent } from '../../../shared/components/banner/banner.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    imports: [
        NgIf,
        BannerComponent,
        NgFor,
        RenderMarkdownComponent,
    ],
})
export class PrivacyPolicyComponent extends PageComponent implements OnInit {
  public override pageData: PrivacyPolicy = <PrivacyPolicy>{};

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentByUID('privacy-policy', 'privacy-notice', {
        populate: {
          policies: { populate: '*' },
          banner: {
            populate: {
              slides: { populate: ['image'] },
            },
          },
        },
      })
      .subscribe({
        next: (data: IStrapiDocument<PrivacyPolicy>) => {
          this.parsePageData(data.data.attributes);
          this.titleService.setTitle(
            this.pageData.browser_title ?? environment.defaultTitle
          );
          this.metaService.updateTag({
            name: 'description',
            content:
              this.pageData.meta_description ?? environment.defaultDescription,
          });
        },
        error: () => {
          this.pageRetrievalError = true;
        },
      });
  }

  protected override parsePageData(page: PrivacyPolicy): void {
    super.parsePageData(page);

    this.pageData.policies = page.policies;
  }

  public togglePrivacyPolicy(event: MouseEvent): void {
    const target = <HTMLElement>event.target;
    if (!target.classList.contains('toggled')) {
      target.classList.add('toggled');
    } else {
      target.classList.remove('toggled');
    }
    if (target.parentElement) {
      if (!target.parentElement.classList.contains('show-policy')) {
        target.parentElement.classList.add('show-policy');
      } else {
        target.parentElement.classList.remove('show-policy');
      }
    }
  }
}
